import { difference } from 'lodash-es';

function split(route: string) {
  const routes = route.split('/');
  const result: string[] = [];
  let current = '';
  let tmp = '';
  while ((tmp = routes.shift())) {
    current = current + '/' + tmp;
    result.push(current.substring(1));
  }
  return result;
}

/**
 * 比较两个路由路径，计算它们之间的差异（新增和移除的路径）
 *
 * @param route 目标路由路径字符串
 * @param from 源路由路径字符串，默认为空字符串
 * @returns 包含新增路径和移除路径的对象
 *          - created: 从源路由到目标路由新增的路径数组
 *          - removed: 从源路由到目标路由移除的路径数组
 *
 * @example
 * // 比较路由 '/a/b/c' 和 '/a/d'
 * splitRoutes('/a/b/c', '/a/d')
 * // 返回: {
 * //   created: ['a/b', 'a/b/c'],
 * //   removed: ['a/d']
 * // }
 */
export function splitRoutes(route: string, from = '', isForceReplace?: boolean) {
  // 将目标路由和源路由分别拆分为完整路径层次数组
  const next = split(route);
  const last = split(from);

  if (isForceReplace) {
    // 强制替换，返回空数组
    return {
      created: next,
      removed: [],
    };
  } else {
    // 计算从源路由到目标路由新增的路径
    const created = difference(next, last);

    // 计算从源路由到目标路由移除的路径
    const removed = difference(last, next);

    return {
      created,
      removed,
    };
  }
}
